<template>
    <div>
        <el-form  ref="formData" :model="formData" label-width="200px" size="small" :rules="rules" style="position: relative;">
            <el-alert class="title" :closable="false" title="给您的帐户充值" type="info" />
            <br />
            <div class="Pay">
                <img class="Payimg" src="@/assets/image/paywx.png"/>
            </div>
            <el-form-item label="您的账号：">
                <span>{{ this.$store.state.admin.userName }}</span>
            </el-form-item>
            <el-form-item label="您的保证金(人民币)：">
                <span>{{ total.balance }}</span>
            </el-form-item>
            <el-form-item label="提示：">
                <!-- <span>提交充值申请，后续会有客服联系您，帮您充值。</span> -->
                <span>请扫描右侧二维码支付，然后填写下方信息。</span>
                <br>
                <span>最后提交凭证后点击提交。</span>
            </el-form-item>
            <el-form-item label="充值金额(人民币)：" prop="amount">
                <el-input onkeyup="value=value.replace(/[^0-9\.]/g,'')" v-model="formData.amount" maxlength="10" placeholder="请输入您的充值金额" style="width: 400px;"></el-input>
            </el-form-item>
            <el-form-item label="国家区号：">
                <el-select v-model="query.guo" placeholder="国家区号" style="width: 120px" disabled>
                    <el-option v-for="item in radio" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系方式：" prop="contact">
                <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="formData.contact" maxlength="11" placeholder="可选" style="width: 400px;"></el-input>
            </el-form-item>
            <el-form-item label="上传支付凭证：">
                <el-button type="success" size="mini" @click.native="uploadPaymentVoucher()">{{formData.image ? '修改支付凭证' : '上传支付凭证'}}</el-button>
                <img v-if="formData.image" class="PaymentVoucher" :src="formData.image"/>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" size="small" style="margin-left: -150px;" @click="op_ups('formData')" :disabled="disabled">提交</el-button>
            </el-form-item>
        </el-form>
        <up-pay :visible="ctrl.upPayVisible" :formData="formData" :title="ctrl.upPayTitle" @close-callback="closeCllback"></up-pay>
    </div>
</template>

<script>
import * as api from "@/api/user/payorders";
import { isvalidMobile } from "@/utils/validate";
import upPay from "./upPay";
export default {
    components: { upPay },
    data() {
        const validateMobile = (rule, value, callback) => {
            if (!isvalidMobile(value)) {
                callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        return {
            formData: {
                image: ""
            },
            ctrl: {
                upPayVisible: false
            },
            query: {
                guo: "0"
            },
            radio: [
                {
                    id: "0",
                    name: "+86"
                }
            ],
            disabled: false,
            total: "",
            rules: {
                amount: [
                    {
                        required: true,
                        message: "请输入您的充值金额",
                        trigger: "blur"
                    }
                ],
                contact: [
                    {
                        required: true,
                        validator: validateMobile,
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        op_ups(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    // this.$confirm(
                    //     `确定要充值 ${this.formData.amount.replace(
                    //         /\B(?=(\d{3})+(?!\d))/g,
                    //         ","
                    //     )} 人民币吗?`,
                    //     {
                    //         confirmButtonText: "确定",
                    //         cancelButtonText: "取消",
                    //         type: "warning"
                    //     }
                    // )
                    //     .then(() => {
                    if (this.formData.amount < 1) {
                        this.$message({
                            type: "error",
                            message: "请充值大于1人民币"
                        });
                        return;
                    }
                    if (this.formData.image == "") {
                        this.$message({
                            type: "error",
                            message: "请上传支付凭证"
                        });
                        return;
                    }
                    this.formData.currency = "CNY";
                    this.disabled = true;
                    api.charge_request(this.formData)
                        .then(res => {
                            if (res.code === 0) {
                                // 提交成功, 跳转页面
                                this.$message({
                                    message: "提交成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.$router.push({
                                    path: "/shopping/rechargeList"
                                });
                            } else {
                                this.disabled = false;
                                this.$message({
                                    type: "error",
                                    message: "提交失败  " + res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                            this.$router.push({
                                path: "/shopping/rechargeList"
                            });
                            this.$alert(
                                "请查看充值订单是否创建成功！",
                                "网络出现问题",
                                {
                                    confirmButtonText: "确定",
                                    type: "warning"
                                }
                            );
                        });
                } else {
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗回调
        closeCllback() {
            this.ctrl.upPayVisible = false;
        },
        uploadPaymentVoucher() {
            this.ctrl.upPayTitle = "上传支付凭证";
            this.ctrl.upPayVisible = true;
        }
    },
    mounted() {
        api.balance().then(res => {
            if (res.code === 0) {
                this.total = res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.message
                });
            }
        });
    }
};
</script>

<style type="text/scss" lang="scss">
.Pay {
    position: absolute;
    // left: calc(40% + 100px);
    left: 700px;
    top: 60px;
}
.Payimg {
    border: 1px solid #eee;
    width: 250px;
    // object-fit: cover;
    // height: 450px;
}
.PaymentVoucher {
    border: 1px solid #eee;
    width: 350px;
    display: block;
}
</style>
